module.exports = __webpack_public_path__ + "img/pro-p-slider1.8ae8a57e.png";